module.exports = __webpack_public_path__ + "img/Weapon_302.4896a628.png";